export default class LocationModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.name = data.name || '';
    this.state_code = data.state_code || '';
    this.short_name = data.short_name || '';
  }

  get display_name() {

    if (this.short_name) {
      return `${this.name} (${this.short_name})`;
    }

    if (this.state_code) {
      return `${this.name}, ${this.state_code}`;
    }
    return this.name;
  }

  get text() {
    return this.display_name;
  }
}
